import { render, staticRenderFns } from "./CustomerTableMobile.html?vue&type=template&id=a4b0362c&external"
import script from "./CustomerTableMobile.js?vue&type=script&lang=js&external"
export * from "./CustomerTableMobile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports